/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_No_ContentInputs */



/**
* | output |
* | --- |
* | "No content shared yet." |
*
* @param {Community_No_ContentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_no_content = /** @type {((inputs?: Community_No_ContentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_No_ContentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun contenu partagé pour le moment.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todavía no se ha compartido contenido.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum conteúdo compartilhado ainda.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun contenuto condiviso finora.")
	return /** @type {LocalizedString} */ ("No content shared yet.")
});